const links = [
    {
        label: 'Github',
        url: 'https://github.com/nicolaszwier'
    },
    {
        label: 'Linkedin',
        url: 'https://www.linkedin.com/in/nicolaszwier/?locale=en_US'
    },
    // {
    //     label: 'Twitter',
    //     url: 'https://twitter.com/nicolaszwier'
    // },
    // {
    //     label: 'Codepen',
    //     url: 'https://codepen.io/nicolaszwier'
    // },
    // {
    //     label: 'Instagram',
    //     url: 'https://instagram.com/nicolaszwier'
    // }
];

export default links